import { API_BASE, getAuthHeaders, handleApiResponse } from '../api/fetchHelper';
import type { PaperImportSummary, ImportLogEntry } from './types';

export const paperImportApi = {
  // List all imports
  list: async (): Promise<{ imports: PaperImportSummary[]; total: number }> => {
    const response = await fetch(`${API_BASE}/console/paper-imports`, {
      headers: getAuthHeaders(),
    });
    return handleApiResponse(response);
  },

  // Delete import
  delete: async (id: string): Promise<{ deleted: string }> => {
    const response = await fetch(`${API_BASE}/console/paper-imports/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    return handleApiResponse(response);
  },
};

// ── Import Log API ──────────────────────────────────────────────────────

export const importLogApi = {
  list: async (limit = 50): Promise<{ imports: ImportLogEntry[]; total: number }> => {
    const response = await fetch(`${API_BASE}/console/import-log?limit=${limit}`, {
      headers: getAuthHeaders(),
    });
    return handleApiResponse(response);
  },
};
